var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 26,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 26,
  fill: "#DBDBDB",
  rx: 2
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeOpacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.692 20.641v-3.564H8.231A1.23 1.23 0 0 1 7 15.847V7.23A1.23 1.23 0 0 1 8.23 6h13.54A1.23 1.23 0 0 1 23 7.23v8.616a1.23 1.23 0 0 1-1.23 1.23H15l-3.782 3.783a.308.308 0 0 1-.526-.218Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M10.691 13.384h8.616M10.69 9.69h8.616"
}))));
export { SvgMessageIcon as ReactComponent };
export default __webpack_public_path__ + "7ba6c7f8de50c448770ed112658c92df.svg";